document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-restock-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/contact', { method: 'POST', body: formData })
        .then(function () {
          form.style.display = 'none';
          form.parentElement.querySelector('.restock-request__success').style.display = 'block';
        })
        .catch(function () {
          alert('Something went wrong — please try again.');
        });
    });
  });
});

class RestockWatcher {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.variants = JSON.parse(container.querySelector('[data-variant-json]').textContent);
    this.restockBox = document.getElementById('restock-request-' + this.productId);
    this.variantLabel = document.getElementById('restock-variant-label-' + this.productId);
    this.variantInput = document.getElementById('restock-variant-input-' + this.productId);

    document.addEventListener('change', this.handleDocumentChange.bind(this));
    this.checkCurrentVariant();
  }

  handleDocumentChange(event) {
    var el = event.target;
    if (!el.matches('input[type="radio"], select')) return;
    var name = (el.name || '').toLowerCase();
    if (name.indexOf('option') === -1 && name.indexOf('size') === -1 && el.tagName !== 'SELECT') return;
    this.checkCurrentVariant();
  }

  checkCurrentVariant() {
    var selected = [];
    document.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
      selected.push(i.value);
    });
    document.querySelectorAll('select').forEach(function (s) {
      if (s.value) selected.push(s.value);
    });

    var match = this.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.every(function (o) { return selected.indexOf(o) !== -1; });
    });

    if (!match) {
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');
      if (variantId) {
        match = this.variants.find(function (v) { return v.id == variantId; });
      }
    }

    if (match) this.updateVisibility(match);
  }

  updateVisibility(variant) {
    if (!variant.available) {
      this.restockBox.style.display = 'block';
      this.variantLabel.textContent = variant.title;
      this.variantInput.value = variant.title + ' (ID: ' + variant.id + ')';
    } else {
      this.restockBox.style.display = 'none';
    }
  }
}

function initRestockWatchers(root) {
  root.querySelectorAll('[data-restock-watcher]').forEach(function (el) {
    if (el.dataset.restockInitialized) return;
    el.dataset.restockInitialized = 'true';
    new RestockWatcher(el);
  });
}

initRestockWatchers(document);

var restockObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;
      if (node.matches && node.matches('[data-restock-watcher]')) {
        initRestockWatchers(node.parentElement || document);
      } else {
        initRestockWatchers(node);
      }
    });
  });
});
restockObserver.observe(document.body, { childList: true, subtree: true });